import { put, fork, takeEvery, delay } from 'redux-saga/effects';
import fp from 'lodash/fp';

import { ActionPayload } from 'Modules/core/redux';

import { messagingActions as actions } from './actions';
import { ModalType, NotificationType, ShowModalPayload, ShowNotificationPayload } from './types';
import { getErrorData, isInfoError } from './utils';


function* hideMessageTimeout(id, timeout) {
    yield delay(timeout);
    yield put(actions.hideMessage(id));
}

let messageId = 0;
function* showNotification({ $payload }: ActionPayload<ShowNotificationPayload>) {
    const { duration = 10000, ...notification } = $payload;
    const message: NotificationType = {
        id: messageId++,
        isModal: false,
        ...notification,
    };
    yield put(actions.enqueue(message));
    yield fork(hideMessageTimeout, message.id, duration);
}

function* showModal({ $payload: modal }: ActionPayload<ShowModalPayload>) {
    const message: ModalType = {
        id: messageId++,
        isModal: true,
        closeable: true,
        confirmClose: true,
        showCloseButton: true,
        ...modal,
    };
    yield put(actions.enqueue(message));
    return messageId;
}

export const withHideModal = next => function* hideModalWrapper({ $payload: { modalId } }) {
    yield next();
    if (fp.isInteger(modalId))
        yield put(actions.hideMessage(modalId));
};

export const withErrorHandler = key => next => function* errorHandlerWrapper() {
    try {
        yield next();
    } catch (error) {
        const errorData = getErrorData(error);
        // errorType?: 'Info' | 'Error', в случае Info отображаем модальное окно с ошибкой
        if (isInfoError(error)) {
            yield put(actions.showModal({
                type: 'ErrorModal',
                props: errorData,
            }));
        } else {
            yield put(actions.showNotification({
                content: { key, values: { error: errorData.text || errorData.title } },
            }));
        }
    }
};

export const sagas = [
    takeEvery(`${actions.showNotification}`, showNotification),
    takeEvery(`${actions.showModal}`, showModal),
];
